import { Device } from "../../entries/Device"

export namespace DeviceSupports {
	export function projectorControl(device: Device) {
		return device.compareVersion("2.10.0") > 0
	}

	export function playNow(device: Device) {
		return device.compareVersion("2.10.0") > 0
	}

	export function groups(device: Device) {
		// I don't remember the last 2.xx version so fuck it - make it 99
		return device.compareVersion("2.99.0") > 0
	}
}
